module.exports = __webpack_public_path__ + "img/99-icon.94dca4d4.svg";